import { createFileRoute } from "@tanstack/react-router";
import { Page } from "@sx/ui";

import { ProjectSettingsPanel } from "../../workspaces/settings/ProjectSettingsPanel";
import { useProjectId } from "../../shell/project";

export const Route = createFileRoute("/_console/p/$org/$project/settings")({
  component: ProjectSettingsRoute,
});

function ProjectSettingsRoute() {
  const projectId = useProjectId();
  return (
    <Page layout="reading">
      <ProjectSettingsPanel projectId={projectId} withinProject />
    </Page>
  );
}
